import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import pluralize from 'rebook/apps/utils/text/pluralize';
import CroppedImage from 'rebook/apps/utils/components/CroppedImage';
import MultilineEllipsisText from 'rebook/apps/base/components/MultilineEllipsisText';

import styles from './style.scss';


function SeriesList({ series }) {
  return (
    <ul className={styles.seriesList}>
      {series.map((serie, key) => {
        return serie && (
          <li className={styles.seriesItem} key={serie && serie.id ? serie.id : key}>
            <Link to={serie.absolute_url}>
              <div className="billetContainer">
                <div className={styles.series}>
                  <div className={styles.seriesInfo}>
                    <big>
                      <b>
                        <MultilineEllipsisText maxLinesCount="2">
                          {serie.name}
                        </MultilineEllipsisText>
                      </b>
                    </big>
                    <span className={styles.seriesBookCount}>
                      {`${serie.active_book_count} ${pluralize(serie.active_book_count, 'книга', 'книги', 'книг')}`}
                    </span>
                  </div>
                  <CroppedImage
                    className={styles.seriesImage}
                    width={40}
                    height={40}
                    src={serie.cover}
                    alt={serie.name} />
                </div>
              </div>
            </Link>
          </li>
        );
      })}
    </ul>
  );
};

SeriesList.propTypes = {
  series: PropTypes.array.isRequired,
};

export default SeriesList;
